// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleCreate_Container__7pcHt {
    min-height: 100px;
}

.ScheduleCreate_Small__3uzjO {
  font-size: .75rem;
  color: #1da3aa;
  font-style: italic;
}

  .ScheduleCreate_Div30div__Toea4 {
    height: 30px;
    overflow: hidden;
  }

  .ScheduleCreate_Div30div2__Dv5bf {
    overflow: hidden;
  }

  .ScheduleCreate_Div30A__WrGdf {
    color: #666;
    font-weight: 400;
  }

  .ScheduleCreate_Div30M__H\\+Wle {
    overflow: hidden;
    color: #333;
    font-weight: 700;
    /* font-size: .75rem !important; */
  }
  
.ScheduleCreate_BreakTitle__fVafu {
  border-top: 10px solid #e8f0f1;
}

.ScheduleCreate_Close__ChPhk {
  /* color: rgb(28, 131, 131); */
  color: rgb(32, 201, 201);
  padding-right: 5px;
  cursor: pointer;
  font-size: .75rem;
}

.ScheduleCreate_Break__cfILD {
  border-top: 10px solid #d0d9db;
}

.ScheduleCreate_BreakBlack__hF-4W {
  border-top: 5px solid #000;
}

.ScheduleCreate_Hig20__862Hi {
  min-height: 30px;
}

.ScheduleCreate_Icon__4Tr3Y i {
  color: #000;
}

.ScheduleCreate_Item__Bs1yk {
    background-color: #1ea7ae;
    color: #fff;
    cursor: pointer;
  }

  .ScheduleCreate_ItemNu__JEGp9 {
  background-color: #55c8ce;
  color: #fff;
} 

.ScheduleCreate_SceneBox__6UAQm p {
  font-size: .8rem !important;
  font-weight: 700;
}

.ScheduleCreate_HrSched__yElgc {
  border-top: 2px solid #fff;
}

/* hr {
  border-top: 1px solid #c1f1f7;
} */

.ScheduleCreate_InputBar__QWJ3m {
  height: 30px !important;
  font-size: .75rem !important;
  border-radius: 20px;
  color: #242a3d;
}

.ScheduleCreate_UnderGold__Xk61l {
  border-bottom: rgba(129, 102, 21, 0.99);
}

.ScheduleCreate_Para2__z-C\\+a {
  font-size: .75rem !important;
  color: #000;
}

.ScheduleCreate_Para3Sh__4BLJY {
  font-size: .75rem !important;
  font-weight: 600;
  color: #0c414f;
  font-style: italic;
}

.ScheduleCreate_Para2Sh__PtjvT {
  font-size: .75rem !important;
  color: #0b343f;
  font-style: italic;
}

.ScheduleCreate_Para3__3JETz {
  font-size: .75rem !important;
  font-weight: 600;
  color: #000;
  font-style: italic;
}

.ScheduleCreate_BottomScene__Ci646 {
  border-bottom: 2px solid #708386;
}

.ScheduleCreate_BottomScene2m__0MLF7 {
  border-bottom: 2px solid #fff;
}

.ScheduleCreate_White__jxHaj {
  background-color: #fff;
}

.ScheduleCreate_HrSched__yElgc {
  border-top: 2px solid #fff;
}

.ScheduleCreate_HrSchedNext__7XF3N {
  border-top: 5px solid #fff;
}

.ScheduleCreate_Break1__QeHLI {
  border-top: 1px solid #d0d9db;
}

.ScheduleCreate_Break2__5xkzx {
  border-top: 5px solid #d0d9db;
}

.ScheduleCreate_BorderRight__Outtx {
  border-right: 1px solid #c1f1f7;
}

.ScheduleCreate_SearchBar__NKHA6 input {
  border-radius: 20px;
  color: #242a3d;
  padding-left: 40px;
  margin-bottom: 16px;
}

.ScheduleCreate_Info__tbSa- {
  font-size: .75rem !important;
  font-weight: 700;
  /* color: rgb(170, 27, 55); */
  color: rgb(183, 44, 72);
  cursor: pointer;
  font-style: italic;
}

.ScheduleCreate_Info__tbSa-:hover {
  color: rgb(107, 10, 29);;
}

.ScheduleCreate_White__jxHaj {
  background-color: #fff;
}

.ScheduleCreate_Back__bXOQK {
  background-color: aliceblue;
}

.ScheduleCreate_Container2__6UIM8 {
    min-height: 10px;
  }

.ScheduleCreate_Bold__TOaio { 
  font-weight: 700;
}
  
.ScheduleCreate_BoldScene__MBej0 {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.ScheduleCreate_BoldSceneNext__RzwOa {
  color: rgba(108, 84, 15, 0.99);
  /* color: #747686; */
  font-style: italic;
  font-weight: 400;
}

.ScheduleCreate_Input__IINY1 {
  background: #ffffff;
  /* border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #494d70;
  padding: 0px 10px;
  height: 30px !important;
  text-align: center;
}

.ScheduleCreate_InputScene__N0Q8Z {
 background: #ffffff;
 /* border: 1px solid #c1f1f7; */
 border-bottom: 1px #00d1ff solid;
 border-top: 1px solid #fff;
 border-right: 1px solid #fff;
 border-left: 1px solid #fff;
 box-sizing: border-box;
 border-radius: 2px;
 color: #494d70;
 padding: 0px 10px;
 text-align: center;
 min-height: 30px;
}

.ScheduleCreate_InputEx__cPTMA {
  background: #ffffff;
  /* border: 1px solid #dee1f7; */
  border: 1px solid #c1f1f7;
  /* border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff; */
  box-sizing: border-box;
  border-radius: 2px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 30px;
  height: 30px !important;
  text-align: center;
  color: #494d70;
}

.ScheduleCreate_InputSceneNext__8o4nR {
  background: #ffffff;
  /* border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #747686;
  color: #494d70;
  padding: 0px 10px;
  text-align: center;
  min-height: 30px;
 }

.ScheduleCreate_Number__wjnUt {
  border-right: 1px solid #eaf2fa;
}

.ScheduleCreate_Infobox__Gj8Tq {
  background-color: #000;
}

.ScheduleCreate_BoldTitle__69AJ1 {
  font-weight: 700;
  background-color: #d6fcff;
}

.ScheduleCreate_BoldTitle2__O1dOU {
  font-weight: 700;
  border-right : 3px solid #fafafa;
  background-color: #d6fcff;
}

.ScheduleCreate_TitleBox__uGZcx {
  background-color: #e8f0f1;
  color: #666;
}

.ScheduleCreate_TitleBox2__CsY\\+J {
  border-right : 2px solid #fff;
  color: #000;
}

.ScheduleCreate_TitleBox2__CsY\\+J i {
  color: #000;
}

.ScheduleCreate_TitleBox3__tcSBH {
  color: #666;
}

.ScheduleCreate_Costume__7PiUE {
  color: rgb(21, 164, 186);
}

.ScheduleCreate_HSpan__stfX6 {
  font-size: .75rem;
  font-weight: 400;
}

.ScheduleCreate_SubTitle__EwkjQ {
  background-color: #e8f0f1;
}

.ScheduleCreate_FormBox__VJ74H {
  background-color: #fff;
}

.ScheduleCreate_Width__OS7oI {
  width: 50%;
}

.ScheduleCreate_Width2__eTFfQ {
  width: 80%;
}

.ScheduleCreate_Width3__Xk8jf {
  width: 80%;
}

.ScheduleCreate_Width95__FyVc6 {
  width: 95%;
}

.ScheduleCreate_Next1__28Xoj {
  /* background-color: #14404f;
  color: #fff; */
  background-color: #fffff5;
  font-weight: 700;
}

.ScheduleCreate_Next2__0\\+uLV {
  /* background-color: #14404f;
  color: #fff; */
  background-color: #fffff5;
  font-weight: 700;
  /* border-top: 1px solid #d0d9db; */
}

.ScheduleCreate_PostDropdown__FHmCN i {
  color: #000;
}

.ScheduleCreate_Drop__CXWzh i {
  color: #000 !important;
}

/* info */

.ScheduleCreate_SceneBox__6UAQm {
  border: 1px solid #fafafa;
  background-color: #fff;
}

.ScheduleCreate_SubTitle__EwkjQ {
  background-color: #e8f0f1;
}

.ScheduleCreate_OrderBox__TF4Jl {
  background-color: #fff;
  border: 2px solid #e8f0f1;
}

@media screen and (max-width: 600px) {
  .ScheduleCreate_InputBar__QWJ3m {
    height: 20px !important;
    font-size: .75rem !important;
}

  .ScheduleCreate_Width__OS7oI {
    width: 80%;
  }
}

@media screen and (max-width: 780px) {
  .ScheduleCreate_Width3__Xk8jf {
    width: 50%;
  }

  .ScheduleCreate_BoldScene__MBej0 {
    font-size: .75rem !important;
  }

  .ScheduleCreate_BoldSceneNext__RzwOa {
    font-size: .75rem !important;
  }

  .ScheduleCreate_Input__IINY1 {
    height: 20px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .ScheduleCreate_InputScene__N0Q8Z {
    font-size: .75rem !important;
   }

   .ScheduleCreate_InputEx__cPTMA {
    font-size: .75rem !important;
    height: 20px !important;
  }

   .ScheduleCreate_InputSceneNext__8o4nR {
    font-size: .75rem !important;
   }
  
}`, "",{"version":3,"sources":["webpack://./src/styles/ScheduleCreate.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;EAEE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kCAAkC;EACpC;;AAEF;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;EAEA;EACA,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;IACI,gBAAgB;EAClB;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;CAC1B,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB;;;gCAG8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;CACjB;;AAED;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;gBACc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;gBACc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,SAAS;;AAET;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;IACvB,4BAA4B;AAChC;;EAEE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;GAC7B;;GAEA;IACC,4BAA4B;IAC5B,uBAAuB;EACzB;;GAEC;IACC,4BAA4B;GAC7B;;AAEH","sourcesContent":[".Container {\n    min-height: 100px;\n}\n\n.Small {\n  font-size: .75rem;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n  .Div30div {\n    height: 30px;\n    overflow: hidden;\n  }\n\n  .Div30div2 {\n    overflow: hidden;\n  }\n\n  .Div30A {\n    color: #666;\n    font-weight: 400;\n  }\n\n  .Div30M {\n    overflow: hidden;\n    color: #333;\n    font-weight: 700;\n    /* font-size: .75rem !important; */\n  }\n  \n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Close {\n  /* color: rgb(28, 131, 131); */\n  color: rgb(32, 201, 201);\n  padding-right: 5px;\n  cursor: pointer;\n  font-size: .75rem;\n}\n\n.Break {\n  border-top: 10px solid #d0d9db;\n}\n\n.BreakBlack {\n  border-top: 5px solid #000;\n}\n\n.Hig20 {\n  min-height: 30px;\n}\n\n.Icon i {\n  color: #000;\n}\n\n.Item {\n    background-color: #1ea7ae;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .ItemNu {\n  background-color: #55c8ce;\n  color: #fff;\n} \n\n.SceneBox p {\n  font-size: .8rem !important;\n  font-weight: 700;\n}\n\n.HrSched {\n  border-top: 2px solid #fff;\n}\n\n/* hr {\n  border-top: 1px solid #c1f1f7;\n} */\n\n.InputBar {\n  height: 30px !important;\n  font-size: .75rem !important;\n  border-radius: 20px;\n  color: #242a3d;\n}\n\n.UnderGold {\n  border-bottom: rgba(129, 102, 21, 0.99);\n}\n\n.Para2 {\n  font-size: .75rem !important;\n  color: #000;\n}\n\n.Para3Sh {\n  font-size: .75rem !important;\n  font-weight: 600;\n  color: #0c414f;\n  font-style: italic;\n}\n\n.Para2Sh {\n  font-size: .75rem !important;\n  color: #0b343f;\n  font-style: italic;\n}\n\n.Para3 {\n  font-size: .75rem !important;\n  font-weight: 600;\n  color: #000;\n  font-style: italic;\n}\n\n.BottomScene {\n  border-bottom: 2px solid #708386;\n}\n\n.BottomScene2m {\n  border-bottom: 2px solid #fff;\n}\n\n.White {\n  background-color: #fff;\n}\n\n.HrSched {\n  border-top: 2px solid #fff;\n}\n\n.HrSchedNext {\n  border-top: 5px solid #fff;\n}\n\n.Break1 {\n  border-top: 1px solid #d0d9db;\n}\n\n.Break2 {\n  border-top: 5px solid #d0d9db;\n}\n\n.BorderRight {\n  border-right: 1px solid #c1f1f7;\n}\n\n.SearchBar input {\n  border-radius: 20px;\n  color: #242a3d;\n  padding-left: 40px;\n  margin-bottom: 16px;\n}\n\n.Info {\n  font-size: .75rem !important;\n  font-weight: 700;\n  /* color: rgb(170, 27, 55); */\n  color: rgb(183, 44, 72);\n  cursor: pointer;\n  font-style: italic;\n}\n\n.Info:hover {\n  color: rgb(107, 10, 29);;\n}\n\n.White {\n  background-color: #fff;\n}\n\n.Back {\n  background-color: aliceblue;\n}\n\n.Container2 {\n    min-height: 10px;\n  }\n\n.Bold { \n  font-weight: 700;\n}\n  \n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.BoldSceneNext {\n  color: rgba(108, 84, 15, 0.99);\n  /* color: #747686; */\n  font-style: italic;\n  font-weight: 400;\n}\n\n.Input {\n  background: #ffffff;\n  /* border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #494d70;\n  padding: 0px 10px;\n  height: 30px !important;\n  text-align: center;\n}\n\n.InputScene {\n background: #ffffff;\n /* border: 1px solid #c1f1f7; */\n border-bottom: 1px #00d1ff solid;\n border-top: 1px solid #fff;\n border-right: 1px solid #fff;\n border-left: 1px solid #fff;\n box-sizing: border-box;\n border-radius: 2px;\n color: #494d70;\n padding: 0px 10px;\n text-align: center;\n min-height: 30px;\n}\n\n.InputEx {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7; */\n  border: 1px solid #c1f1f7;\n  /* border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff; */\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 30px;\n  height: 30px !important;\n  text-align: center;\n  color: #494d70;\n}\n\n.InputSceneNext {\n  background: #ffffff;\n  /* border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #747686;\n  color: #494d70;\n  padding: 0px 10px;\n  text-align: center;\n  min-height: 30px;\n }\n\n.Number {\n  border-right: 1px solid #eaf2fa;\n}\n\n.Infobox {\n  background-color: #000;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: #d6fcff;\n}\n\n.BoldTitle2 {\n  font-weight: 700;\n  border-right : 3px solid #fafafa;\n  background-color: #d6fcff;\n}\n\n.TitleBox {\n  background-color: #e8f0f1;\n  color: #666;\n}\n\n.TitleBox2 {\n  border-right : 2px solid #fff;\n  color: #000;\n}\n\n.TitleBox2 i {\n  color: #000;\n}\n\n.TitleBox3 {\n  color: #666;\n}\n\n.Costume {\n  color: rgb(21, 164, 186);\n}\n\n.HSpan {\n  font-size: .75rem;\n  font-weight: 400;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n}\n\n.FormBox {\n  background-color: #fff;\n}\n\n.Width {\n  width: 50%;\n}\n\n.Width2 {\n  width: 80%;\n}\n\n.Width3 {\n  width: 80%;\n}\n\n.Width95 {\n  width: 95%;\n}\n\n.Next1 {\n  /* background-color: #14404f;\n  color: #fff; */\n  background-color: #fffff5;\n  font-weight: 700;\n}\n\n.Next2 {\n  /* background-color: #14404f;\n  color: #fff; */\n  background-color: #fffff5;\n  font-weight: 700;\n  /* border-top: 1px solid #d0d9db; */\n}\n\n.PostDropdown i {\n  color: #000;\n}\n\n.Drop i {\n  color: #000 !important;\n}\n\n/* info */\n\n.SceneBox {\n  border: 1px solid #fafafa;\n  background-color: #fff;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n}\n\n.OrderBox {\n  background-color: #fff;\n  border: 2px solid #e8f0f1;\n}\n\n@media screen and (max-width: 600px) {\n  .InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n}\n\n  .Width {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 780px) {\n  .Width3 {\n    width: 50%;\n  }\n\n  .BoldScene {\n    font-size: .75rem !important;\n  }\n\n  .BoldSceneNext {\n    font-size: .75rem !important;\n  }\n\n  .Input {\n    height: 20px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .InputScene {\n    font-size: .75rem !important;\n   }\n\n   .InputEx {\n    font-size: .75rem !important;\n    height: 20px !important;\n  }\n\n   .InputSceneNext {\n    font-size: .75rem !important;\n   }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ScheduleCreate_Container__7pcHt`,
	"Small": `ScheduleCreate_Small__3uzjO`,
	"Div30div": `ScheduleCreate_Div30div__Toea4`,
	"Div30div2": `ScheduleCreate_Div30div2__Dv5bf`,
	"Div30A": `ScheduleCreate_Div30A__WrGdf`,
	"Div30M": `ScheduleCreate_Div30M__H+Wle`,
	"BreakTitle": `ScheduleCreate_BreakTitle__fVafu`,
	"Close": `ScheduleCreate_Close__ChPhk`,
	"Break": `ScheduleCreate_Break__cfILD`,
	"BreakBlack": `ScheduleCreate_BreakBlack__hF-4W`,
	"Hig20": `ScheduleCreate_Hig20__862Hi`,
	"Icon": `ScheduleCreate_Icon__4Tr3Y`,
	"Item": `ScheduleCreate_Item__Bs1yk`,
	"ItemNu": `ScheduleCreate_ItemNu__JEGp9`,
	"SceneBox": `ScheduleCreate_SceneBox__6UAQm`,
	"HrSched": `ScheduleCreate_HrSched__yElgc`,
	"InputBar": `ScheduleCreate_InputBar__QWJ3m`,
	"UnderGold": `ScheduleCreate_UnderGold__Xk61l`,
	"Para2": `ScheduleCreate_Para2__z-C+a`,
	"Para3Sh": `ScheduleCreate_Para3Sh__4BLJY`,
	"Para2Sh": `ScheduleCreate_Para2Sh__PtjvT`,
	"Para3": `ScheduleCreate_Para3__3JETz`,
	"BottomScene": `ScheduleCreate_BottomScene__Ci646`,
	"BottomScene2m": `ScheduleCreate_BottomScene2m__0MLF7`,
	"White": `ScheduleCreate_White__jxHaj`,
	"HrSchedNext": `ScheduleCreate_HrSchedNext__7XF3N`,
	"Break1": `ScheduleCreate_Break1__QeHLI`,
	"Break2": `ScheduleCreate_Break2__5xkzx`,
	"BorderRight": `ScheduleCreate_BorderRight__Outtx`,
	"SearchBar": `ScheduleCreate_SearchBar__NKHA6`,
	"Info": `ScheduleCreate_Info__tbSa-`,
	"Back": `ScheduleCreate_Back__bXOQK`,
	"Container2": `ScheduleCreate_Container2__6UIM8`,
	"Bold": `ScheduleCreate_Bold__TOaio`,
	"BoldScene": `ScheduleCreate_BoldScene__MBej0`,
	"BoldSceneNext": `ScheduleCreate_BoldSceneNext__RzwOa`,
	"Input": `ScheduleCreate_Input__IINY1`,
	"InputScene": `ScheduleCreate_InputScene__N0Q8Z`,
	"InputEx": `ScheduleCreate_InputEx__cPTMA`,
	"InputSceneNext": `ScheduleCreate_InputSceneNext__8o4nR`,
	"Number": `ScheduleCreate_Number__wjnUt`,
	"Infobox": `ScheduleCreate_Infobox__Gj8Tq`,
	"BoldTitle": `ScheduleCreate_BoldTitle__69AJ1`,
	"BoldTitle2": `ScheduleCreate_BoldTitle2__O1dOU`,
	"TitleBox": `ScheduleCreate_TitleBox__uGZcx`,
	"TitleBox2": `ScheduleCreate_TitleBox2__CsY+J`,
	"TitleBox3": `ScheduleCreate_TitleBox3__tcSBH`,
	"Costume": `ScheduleCreate_Costume__7PiUE`,
	"HSpan": `ScheduleCreate_HSpan__stfX6`,
	"SubTitle": `ScheduleCreate_SubTitle__EwkjQ`,
	"FormBox": `ScheduleCreate_FormBox__VJ74H`,
	"Width": `ScheduleCreate_Width__OS7oI`,
	"Width2": `ScheduleCreate_Width2__eTFfQ`,
	"Width3": `ScheduleCreate_Width3__Xk8jf`,
	"Width95": `ScheduleCreate_Width95__FyVc6`,
	"Next1": `ScheduleCreate_Next1__28Xoj`,
	"Next2": `ScheduleCreate_Next2__0+uLV`,
	"PostDropdown": `ScheduleCreate_PostDropdown__FHmCN`,
	"Drop": `ScheduleCreate_Drop__CXWzh`,
	"OrderBox": `ScheduleCreate_OrderBox__TF4Jl`
};
export default ___CSS_LOADER_EXPORT___;
